import { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faTableCellsLarge,
    faGaugeHigh,
    faGear,
    faMapLocationDot,
    faBolt,
    faShieldHalved,
    faRightFromBracket,
    faBars,
    faXmark,
} from '@fortawesome/free-solid-svg-icons';
import MyModalActivation from './ActivationModal/MyModalActivation';
import Logo from 'assets/img/Logo_EPS_300.png';
import 'assets/styles/account.css';

export default function Sidebar() {
    const [modalIsOpen, setIsOpen] = useState(false);
    const [showSidebar, setShowSidebar] = useState(false);
    const user = useSelector(state => state.userGlobal.user);
    const location = useLocation();
    const accountRoutes = ['/compte', '/classe', '/suivi_eval', '/fil_annuel', '/note'];
    const isAccountArea = accountRoutes.includes(location.pathname);

    const closeNavigation = () => setShowSidebar(false);

    return (
        <>
            <MyModalActivation
                IsModalOpened={modalIsOpen}
                onCloseModal={(event, data) => { if (data === 1) setIsOpen(false); }}
                key={modalIsOpen ? 'activation-open' : 'activation-closed'}
            />

            <button
                type="button"
                className="ae-sidebar-mobile-trigger"
                onClick={() => setShowSidebar(true)}
                aria-label="Ouvrir le menu"
            >
                <FontAwesomeIcon icon={faBars} />
            </button>

            <div
                className={`ae-sidebar-backdrop${showSidebar ? ' is-visible' : ''}`}
                onClick={closeNavigation}
                aria-hidden="true"
            />

            <aside className={`ae-sidebar${showSidebar ? ' is-open' : ''}`}>
                <button
                    type="button"
                    className="ae-sidebar-close"
                    onClick={closeNavigation}
                    aria-label="Fermer le menu"
                >
                    <FontAwesomeIcon icon={faXmark} />
                </button>

                <NavLink to="/compte" className="ae-sidebar-logo" onClick={closeNavigation}>
                    <img src={Logo} alt="Accès EPS" />
                </NavLink>

                <nav className="ae-sidebar-nav" aria-label="Navigation principale">
                    {user.admin === true && (
                        <NavLink to="/dashboard" exact className="ae-sidebar-link" activeClassName="is-active" onClick={closeNavigation}>
                            <FontAwesomeIcon icon={faGaugeHigh} />
                            <span>Dashboard</span>
                        </NavLink>
                    )}
                    {user.admin === true && (
                        <NavLink to="/settings" className="ae-sidebar-link" activeClassName="is-active" onClick={closeNavigation}>
                            <FontAwesomeIcon icon={faGear} />
                            <span>Options</span>
                        </NavLink>
                    )}
                    <NavLink to="/compte" className={`ae-sidebar-link${isAccountArea ? ' is-active' : ''}`} activeClassName="is-active" onClick={closeNavigation}>
                        <FontAwesomeIcon icon={faTableCellsLarge} />
                        <span>Compte</span>
                    </NavLink>
                    {user.admin === true && (
                        <NavLink to="/maps" className="ae-sidebar-link" activeClassName="is-active" onClick={closeNavigation}>
                            <FontAwesomeIcon icon={faMapLocationDot} />
                            <span>Maps</span>
                        </NavLink>
                    )}
                </nav>

                <div className="ae-sidebar-actions">
                    <button type="button" className="ae-sidebar-action ae-sidebar-action--activation" onClick={() => setIsOpen(true)}>
                        <FontAwesomeIcon icon={faBolt} />
                        <span>Code d'activation</span>
                    </button>
                    <a className="ae-sidebar-action ae-sidebar-action--terms" href="https://acces-editions.com/acces-eps-cgvu" rel="noreferrer" target="_blank">
                        <FontAwesomeIcon icon={faShieldHalved} />
                        <span>CGU - CGV</span>
                    </a>
                    <a className="ae-sidebar-action ae-sidebar-action--logout" href="/logout">
                        <FontAwesomeIcon icon={faRightFromBracket} />
                        <span>Déconnexion</span>
                    </a>
                </div>
            </aside>
        </>
    );
}
